import React, {useState} from "react";
import ListView from "../components/Entity/ListView";

const columns = [
    {
        title: "Имя пользователя",
        dataIndex: 'username',
        key: 'username',
    },
    {
        title: "ФИО",
        dataIndex: 'FIO',
        key: 'FIO',
    }
]

const UserEditorPage = () => {
    return <ListView config={{getAll: {method: 'POST', url: '/api/auth/users'}}} columns={columns} />
}

export default UserEditorPage